exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bar-tabs {\r\n    height: 30px;\r\n    border-bottom: 2px solid #d6d6d6;\r\n}\r\n\r\n.item-incomplete {\r\n    color: #d6d6d6;\r\n}\r\n\r\n.item-complete {\r\n   color: black;\r\n}\r\n\r\n.item-selected {\r\n    color: black;\r\n    height: 29px;\r\n    font-weight: 600;\r\n    border-bottom: 3px solid #41D78C;\r\n}\r\n\r\n.icon-selected {\r\n    margin-top: -6px;\r\n}\r\n\r\n.clickable {\r\n    cursor: pointer;\r\n    color: #868686;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/tab/tab.component.css
// module id = ../../../../../src/app/components/tab/tab.component.css
// module chunks = main